import React from 'react';
import { Carousel, Container } from 'react-bootstrap';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ContactSignUp from '../../Components/ContactSignUp';



function Technology(props) {

   return (
      <div className='container-fluid'>

         <div className='row  mb-5 technology-Header' style={{ backgroundImage: `url(../../../server-build/Images/FruitListingsHeader.png)` }}>
            <div className='col'>
               <div className='row justify-content-center align-items-center h-100 w-100 text-center '>
                  <div className='col-auto'>
                     <h2 className='mb-3'>India’s first connected<br /> fresh fruit supply chain</h2>
                     <p className='fw-semibold'>Getting fresh fruits across the country to you isn’t easy. We’ve had to reimagine a complete nationwide <br />
                        cold chain with innovative processes, hardware and software to do just that. For the first time in India, <br />
                        we can ensure food safety, pesticide levels and the condition in which your favourite fruits get to you.</p>
                  </div>
               </div>
            </div>
         </div>

        

         <div className='row pt-0 pt-lg-5 mb-5 pb-0 pb-lg-5'>
            <div className='col'>
               <Container  >
                  <div className='row  mb-5 rounded-5 justify-content-center align-items-center tech-container1'>
                     <div className='col-12 col-lg-6'>
                        <div className='row justify-content-center ps-2 ps-lg-5'>

                           <h2>Prioritising  Quality</h2>

                           <p>Our advanced tracking system allows us to monitor and maintain<br className='d-none d-lg-block' />
                              stringent quality parameters at every stage of the journey. From the<br className='d-none d-lg-block' />
                              moment a fruit is harvested, we employ cutting-edge technology to<br  className='d-none d-lg-block'/>
                              assess factors like ripeness, freshness, and overall quality.</p>

                        </div>

                     </div>
                     <div className='col-6 d-none d-lg-block'>


                     </div>
                  </div>


                  <div className='row  mb-5  rounded-5 justify-content-center align-items-center tech-container2'>
                     <div className='col-6 ps-0 d-none d-lg-block'>
                        <img src="../../../server-build/Images/pt-img-7.jpg" className='img-fluid' />

                     </div>
                     <div className='col-12 col-lg-6'>
                        <div className='row justify-content-center ps-2 ps-lg-5'>

                           <h2>Maintaining Quality <br /> with our Fresherator</h2>

                           <p>Our custom-engineered container seamlessly transforms any <br className='d-none d-lg-block' />
                              truck into a state-of-the-art reefer, ensuring that our fruits <br className='d-none d-lg-block' />
                              travel in optimal conditions. This game-changing technology <br className='d-none d-lg-block'/>
                              allows us to meticulously track and control crucial parameters <br className='d-none d-lg-block' />
                              such as humidity, temperature, oxygen, and ethylene levels</p>
                        </div>




                     </div>

                  </div>


                  <div className='row   mb-5  rounded-5 justify-content-center align-items-center tech-container3'>
                     <div className='col-12 col-lg-6'>
                        <div className='row justify-content-center ps-2 ps-lg-5'>

                           <h2>Tracking Quality <br /> with our <br /> Freshmanage</h2>

                           <p>Our cutting-edge cloud-based software serves as the<br className='d-none d-lg-block' />
                              backbone of all our operations. It is a testament to our<br className='d-none d-lg-block' />
                              dedication to transparency and fairness, empowering both<br className='d-none d-lg-block' />
                              our farmers and consumers with accurate, batchbased<br  className='d-none d-lg-block'/>
                              information. From storing fruit information to calculating<br className='d-none d-lg-block'/>
                              farmer scores, streamlines and enhances every aspect of<br className='d-none d-lg-block' />
                              our operation.</p>

                        </div>

                     </div>
                     <div className='col-6 d-none d-lg-block' >
                     </div>
                  </div>


                  <div className='row  rounded-5 justify-content-center align-items-center tech-container4'>
                     <div className='col-12 co-lg-6'>
                        <div className='row justify-content-center ps-2 ps-lg-5'>
                           <div className='col'>
                              <h2>Delivering <br />Transparency to<br /> Consumers</h2>

                              <p>Our cutting-edge cloud-based software serves as the <br className='d-none d-lg-block' />
                                 backbone of all our operations. It is a testament to our <br className='d-none d-lg-block' />
                                 dedication to transparency and fairness, empowering both <br  className='d-none d-lg-block'/>
                                 our farmers and consumers with accurate, batchbased <br className='d-none d-lg-block' />
                                 information. From storing fruit information to calculating <br className='d-none d-lg-block' />
                                 farmer scores, streamlines and enhances every aspect of our <br className='d-none d-lg-block' />
                                 operation.</p>

                           </div>
                        </div>
                     </div>
                     <div className='col-6 d-none d-lg-block'>
                     </div>
                  </div>
               </Container>
            </div>
         </div >
         <div className='row mb-5 pb-0 pb-lg-5'>
            <div className='col'>
               <Container>
                  <div className='row '>
                     <div className=' col '>
                        <p className='text-decoration-underline'><FontAwesomeIcon icon={faChevronLeft} />&nbsp; <span className='fw-semibold'>Sustainability</span> </p>
                     </div>
                     <div className=' col-auto'>
                        <p className='text-decoration-underline'><span className='fw-semibold'>Partner with us</span> &nbsp; <FontAwesomeIcon icon={faChevronRight} /></p>
                     </div>
                  </div>
               </Container>
            </div>
         </div>

         <div className='row mb-5 pb-0 pb-lg-5'>
            <div className='col'>
               <ContactSignUp />
            </div>
         </div>



      </div>
   );


}

export default Technology; 